import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionReminderComponent } from '@client/shared/components/subscription-reminder/subscription-reminder.component';
@NgModule({
  declarations: [SubscriptionReminderComponent],
  imports: [CommonModule],
  exports: [SubscriptionReminderComponent],
})
export class SubscriptionReminderModule { }
